import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useLang from "@/hooks/useLang";
import type { Lang } from "@/hooks/useLang/types";
import "./styles.css";

const LANG_OPTIONS: { lang: Lang; label: string; flag: string }[] = [
    { lang: "en", label: "English", flag: "/images/english-lang.png" },
    { lang: "ar", label: "العربية", flag: "/images/arabic-lang.png" },
];

export default function ChooseLangScreen() {
    const setLang = useLang((state) => state.setLang);
    const navigate = useNavigate();
    const [selected, setSelected] = useState<Lang | null>(null);

    const handleContinue = () => {
        if (!selected) return;
        setLang(selected);
        navigate("/login");
    };

    return (
        <div className="choose-lang-screen">
            <div className="choose-lang-card">
                <img src="/icons/choose-lang-icon.svg" className="choose-lang-icon" alt="" />
                <div className="choose-lang-options">
                    {LANG_OPTIONS.map(({ lang, label, flag }) => (
                        <button
                            key={lang}
                            type="button"
                            className={`choose-lang-option${selected === lang ? " choose-lang-option--selected" : ""}`}
                            onClick={() => setSelected(lang)}
                        >
                            <img src={flag} className="choose-lang-option-flag" alt={label} />
                            <p className="choose-lang-option-label">{label}</p>
                        </button>
                    ))}
                </div>
                <button type="button" className="choose-lang-continue" onClick={handleContinue} disabled={!selected}>
                    <img src="/icons/arrow-dark-icon.svg" className="choose-lang-continue-arrow" alt="" />
                </button>
            </div>
        </div>
    );
}
